module.exports = __webpack_public_path__ + "static-portal/img/news12-8.65939e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-8.jpg
// module id = 3hbm
// module chunks = 4